/* template */
<template minapp="mpx" xlang="wxml"><div class="coupon-list-container"><div v-for="(item, index) in (listData)" :key="item.index"><coupon-item :couponData="(item)" :couponTheme="(couponTheme)"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m8233ada6"}'>
  .coupon-list-container
    padding 0 15px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m8233ada6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./coupon-list.mpx.js?isComponent&outputPath=components%2Fcoupon-list8233ada6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./coupon-list.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcoupon-list8233ada6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m8233ada6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/coupon-list8233ada6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-item':getComponent(require("./coupon-item.mpx?isComponent&outputPath=components%2Fcoupon-item963e9dbc%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
